//NotificationPush.js

import React, { useCallback, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { useSocket } from '../../SocketContext';
import useNotificationChime from '../../hooks/useNotificationChime';
import CustomNotificationContent from '../CustomNotificationContent';

const NotificationPush = ({ userId }) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { playChime } = useNotificationChime({ requireInteractionForPlay: true });
  const socket = useSocket();

  const handleNotification = useCallback((notification) => {
    if (
      notification.user &&
      userId &&
      notification.user.toString() === userId.toString() &&
      notification.type !== 'newEmail'
    ) {
      playChime();
      enqueueSnackbar('', {
        variant: 'customNotification',
        content: (key) => (
          <CustomNotificationContent
            key={key}
            message={notification}
            closeSnackbar={() => closeSnackbar(key)}
          />
        )
      });
    }
  }, [userId, enqueueSnackbar, closeSnackbar, playChime]);

  useEffect(() => {
    if (!socket) return;
    socket.on('notificationCreated', handleNotification);
    return () => socket.off('notificationCreated', handleNotification);
  }, [socket, handleNotification]);

  return null;
};

export default NotificationPush;
